import { useState, useEffect } from 'react';
/**
 * # useWindowSize
 *
 * 사이즈가 변경되어 갱신된 윈도우 사이즈를 반환한다.
 *
 * @returns {@link WindowSize}
 *
 * @example
 *
 * ```tsx
 * const windowSize = useWindowSize()
 * windowSize.width // usage
 * windowSize.height // usage
 * ```
 */
export function useWindowSize() {
    var _a = useState({
        width: undefined,
        height: undefined
    }), windowSize = _a[0], setWindowSize = _a[1];
    useEffect(function () {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowSize;
}
//# sourceMappingURL=index.js.map